<template>
  <div class="deal_list">
    <app-loading-section :loading="loading" :count="recordDeals.length">
      <template #message>there are no deals this month</template>
      <app-record
        v-for="record in recordDeals"
        :key="record.id"
        :record="record"
        tooltip-position="is-left"
      ></app-record>
    </app-loading-section>
  </div>
</template>

<script>
export default {
  name: "DealListModal",
  data() {
    return {
      loading: true,
      recordDeals: [],
    };
  },
  created() {
    this.$api.records.getDealRecords().then(response => {
      this.recordDeals = response.data;
      this.loading = false;
    });
  }
};
</script>

<style lang="scss" scoped>
.deal_list {
  position: relative;
}
</style>
